exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts-label[data-v-16a42be8]{padding-top:12px;display:inline-block;font-size:16px;line-height:22px;@media (max-width:960px){padding-bottom:10px}}.contacts-label-b2c[data-v-16a42be8]{padding-top:0;display:inline-block;font-size:16px;line-height:22px}.padding-top-small[data-v-16a42be8]{padding-top:2px!important}@media (min-width:960px){.contacts-label-b2c[data-v-16a42be8]{font-size:14px;line-height:20px}}.user-contact-data h3.b2c-title[data-v-16a42be8]{font-size:28px}@media screen and (max-width:960px){.user-contact-data h3.b2c-title[data-v-16a42be8]{font-size:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16a42be8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/fields/User.vue
// module id = QyV2
// module chunks = 0 1